<template id="tabs">
<div class="activities-tabs">
    <ul class="nav nav-tabs nav-tabs-fillup offer">
      <li v-for="tab in tabs" v-bind:class="[{'active': current === tab},'item']" v-on:click="changeTab(tab)">
        <a><span>{{tab.title}}</span></a>
      </li>
    </ul>
    <slot></slot>
  </div>
</template>

<script>
	export default {

	 data: function() {
	    return {
	      tabs: [],
	      current: null
	    };
	  },

	methods: {
	    addTab: function(tab) {
	      this.tabs.push(tab);
	      if (tab.active === true) {
	        this.current = tab;
	      }
	    },

	changeTab: function(tab) {
	      this.current = tab;
	      this.tabs.forEach(function(value) {
	        if (value === tab) {
	          value.active = true;
	        } else {
	          value.active = false;
	        }
	      });
	    },
	}
}

</script>

<style lang="scss">
.activities-tabs {
  max-height: 748px;
  overflow: hidden;
}
.offer {
  background: #f0f0f0;
  border: none;
  margin-bottom: 15px;
  position: sticky;
  top: 0;
  z-index:99;
  li.item {
    margin-bottom: 0;
    a {
      border: none;
      span {
        text-align: center;
      }
    }
    &.active {
      a {
        background: #e7e7e7;
        color: #fb557a;
        border: none;
        &:focus {
          background: #e7e7e7;
        }
        &::after {
          content: '';
          background: none;
          border: 0;
        }
        span {
          text-align: center;
        }
      }
    }
  }
}
/*
.offer .nav-tabs > li.active > a,
.nav-tabs > li.active > a:hover,
.nav-tabs > li.active > a:focus {
    color: #555;
    cursor: default;
    background-color: #fff;
    border: 1px solid #ddd;
    border-bottom-color: transparent;
}
*/

</style>



// WEBPACK FOOTER //
// client/components/Dashboard/ActivitiesLog/ActivitiesTabs.vue